import { render, staticRenderFns } from "./SetCredentials.vue?vue&type=template&id=1ff38de0&scoped=true&"
import script from "./SetCredentials.vue?vue&type=script&lang=js&"
export * from "./SetCredentials.vue?vue&type=script&lang=js&"
import style0 from "./SetCredentials.vue?vue&type=style&index=0&id=1ff38de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff38de0",
  null
  
)

export default component.exports